import React from "react";

import Button from "../Button";

import "./style.scss";

interface CarouselNavigationProps {
  activeIndex: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
}

const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  activeIndex,
  total,
  onPrev,
  onNext,
  disablePrev = false,
  disableNext = false,
}) => {
  return (
    <div className="flex flex-wrap carousel-navigation justify-between items-center">
      <div className="w-auto">
        <Button
          className="nav-btn left"
          onClick={onPrev}
          disabled={disablePrev}
          variant="clear"
        >
          <span className="arrow">&#8249;</span>
        </Button>
      </div>

      <div className="w-auto">
        <div className="dots">
          {Array.from({ length: total }).map((_, index) => (
            <span
              key={index}
              className={`dot ${index === activeIndex ? "active" : ""}`}
            />
          ))}
        </div>
      </div>

      <div className="w-auto">
        <Button
          className="nav-btn right"
          onClick={onNext}
          disabled={disableNext}
          variant="clear"
        >
          <span className="arrow">&#8250;</span>
        </Button>
      </div>
    </div>
  );
};

export default CarouselNavigation;
